export const NEW_SCREEN_ENABLED = ['FC_INBOUND', 'TRACK_TRACE', 'SDC_INBOUND', 'CENTER_POINT']